import type { CSSProperties } from 'react';
import { cx } from '../../lib/cx';
import './voice-wave.css';

// A few bars, each its own height and pace, so they move like a voice rather than in step.
const BARS = [
  { '--peak': 0.55, '--pace': '520ms' },
  { '--peak': 0.9, '--pace': '430ms' },
  { '--peak': 1, '--pace': '610ms' },
  { '--peak': 0.75, '--pace': '470ms' },
  { '--peak': 0.5, '--pace': '560ms' },
].map((bar, index) => ({ ...bar, '--bar': index }) as CSSProperties);

/**
 * A little spectrum, in place of a Read aloud button's icon while it reads: waiting for the
 * voice, a ripple runs across it; speaking, its bars rise and fall. Only to look at: the button
 * says what's going on.
 */
export function VoiceWave({ status }: { readonly status: 'loading' | 'playing' }) {
  return (
    <span className={cx('voice-wave', `is-${status}`)} aria-hidden="true">
      {BARS.map((style, bar) => (
        <span key={bar} className="voice-wave-bar" style={style} />
      ))}
    </span>
  );
}
